// extracted by mini-css-extract-plugin
export default {"LoyalityProgram":"loyaltyProgramSection_LoyalityProgram__W3IWV","Container":"loyaltyProgramSection_Container__fnELh"};